import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/layout";
import * as XLSX from "xlsx";

const HostelAccomodationCharges = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Load the file from the public folder or assets folder
    fetch(`${process.env.PUBLIC_URL}/data1.xlsx`)
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setData(jsonData);
      })
      .catch((error) => console.error("Error loading file:", error));
  }, []);

  return (
    <Layout>
      <main className="bg-gray-100 pt-[30vw] mt-[5vw]">
        <div className="flex justify-center">
          <div className="flex absolute md:mt-[-45vw] mt-[-45vw] md:flex-row flex-col items-center w-full justify-center gap-12">
            <div
              className="text-[55px] text-white"
              style={{
                fontFamily: "Bebas Neue",
                textShadow: "2px 1px 0px #000",
              }}
            >
              ACCOMODATION
            </div>
          </div>
          <div className="w-full md:w-3/4 md:px-20 px-10 py-32 border-2 mb-20 bg-white md:mt-[-25vw] mt-[-15vw]">
            <div
              style={{
                overflowX: "auto",
                scrollbarWidth: "thin",
                WebkitOverflowScrolling: "touch",
              }}
            >
              <style>
                {`
                  /* Width */
                  div::-webkit-scrollbar {
                    height: 8px;
                  }

                  /* Track */
                  div::-webkit-scrollbar-track {
                    background: #f1f1f1;
                  }

                  /* Handle */
                  div::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 4px;
                  }

                  /* Handle on hover */
                  div::-webkit-scrollbar-thumb:hover {
                    background: #555;
                  }
                `}
              </style>
              <table
                style={{
                  marginTop: "20px",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    {data.length > 0 &&
                      Object.keys(data[0]).map((key, index) => (
                        <th
                          key={key}
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            width:
                              index === Object.keys(data[0]).length - 1
                                ? "100px"
                                : "auto",
                          }}
                        >
                          {key}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {Object.values(row).map((value, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            border: "1px solid black",
                            padding: "8px",
                            width:
                              colIndex === Object.values(row).length - 1
                                ? "100px"
                                : "auto",
                          }}
                        >
                          {value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default HostelAccomodationCharges;
